import axios from 'axios'

// 获取地址栏参数  e 为需要获取的参数名
function getUrlQuery(e) {
  let reg = new RegExp("(^|&)"+ e +"=([^&]*)(&|$)")
  let r = window.location.search.substr(1).match(reg)
  if( r != null ) {
    return unescape(r[2])
  } else {
    return null
  }
}

export const baseURL = process.env.VUE_APP_BASE_API || location.origin

const server = axios.create({
	// 请求公共地址
    baseURL,
    // 超时时间
    timeout: 10000
})

// 请求拦截
server.interceptors.request.use(config => {
  return config
}, err => {
  Promise.reject(err)
})

// 响应拦截
server.interceptors.response.use(res => {
  if (res.status && res.status !== 200) {
    return Promise.reject(res.data.msg || 'error')
  } else {
    return Promise.resolve(res.data)
  }
}, err => {
  return Promise.reject(err)
})

export default server
